<template>
  <!-- first -->
  <section class="px-10 py-8">
    <h3 class="text-black text-center text-2xl lg:text-3xl font-semibold">
      Enter OTP
    </h3>
    <p class="my-5 text-center text-gray-600 text-sm">
      An OTP was sent to your slack account <br />
      <span class="font-semibold text-primary underline">{{ adminEmail }}</span>
    </p>
    <el-form
      ref="auth"
      :model="auth"
      :rules="rules"
      label-position="top"
      @keyup.enter.native="validateForm('auth')"
    >
      <el-form-item prop="otp" label="OTP">
        <el-input v-model.trim="auth.otp" placeholder="Enter your OTP" />
        <el-input v-model="hiddenInput" class="hidden" />
      </el-form-item>
      <el-form-item>
        <div class="flex items-center justify-between gap-x-3 mt-6 w-full">
          <el-button
            class="w-full text-fg-muted rounded-lg py-4"
            @click="goBack"
            >Back</el-button
          >
          <el-button
            @click="validateForm('auth')"
            :loading="isLoading"
            class="w-full text-white rounded-lg py-4 bg-primary"
            :class="bgPrimary"
            >Sign Action</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import { USER_TOKEN, ADMIN_TENANT, ADMIN_EMAIL } from '@/utils/constants'
export default {
  data () {
    return {
      hiddenInput: '',
      auth: {
        otp: ''
      },
      rules: {
        otp: [
          {
            required: true,
            message: 'Please a valid otp',
            trigger: ['blur', 'change']
          }
        ]
      },
      isLoading: false
    }
  },
  computed: {
    bgPrimary () {
      return localStorage.getItem(ADMIN_TENANT) === this.$tenants.OVAL
        ? 'bg-oval'
        : 'bg-torus'
    },
    adminEmail () {
      return localStorage.getItem(ADMIN_EMAIL)
    }
  },
  methods: {
    goBack () {
      this.$emit('toggle-view', 'enter-admin-email')
    },
    validateForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.verifyAdminBusinessAccess()
        } else {
          this.$notify.error({
            title: 'Invalid OTP',
            message: 'please enter a valid otp',
            position: 'top-right'
          })
        }
      })
    },
    async verifyAdminBusinessAccess () {
      const vm = this
      this.isLoading = true
      const payload = {
        eventID: this.$store.state.auth.adminBusinessAccessDetails.accessKey,
        otp: this.auth.otp
      }
      this.$store
        .dispatch('auth/verifyAdminBusinessAccess', payload)
        .then(async () => {
          this.isLoading = false
          const verifiedAdminDetails =
            this.$store.state.auth.verifiedAdminBusinessAccessDetails
          const user = {
            firstName: 'Admin',
            lastName: 'Admin',
            kind: 1
          }
          const tokens = {
            accessToken: verifiedAdminDetails.AccessToken,
            user,
            accessTokenExpiry: verifiedAdminDetails.AccessTokenExpiry,
            refreshToken: verifiedAdminDetails.RefreshToken,
            business: { completedKyc: true, accountActive: true }
          }
          localStorage.setItem(USER_TOKEN, verifiedAdminDetails.AccessToken)
          this.$store.dispatch('auth/setAdminTokens', tokens)
          this.$router.push('/dashboard')
        })
        .catch((error) => {
          this.isLoading = false
          this.handleErrorResponseNotification(error)
        })
    }
  }
}
</script>
<style scoped>
.bg-oval {
  background: #f26722;
}
.bg-torus {
  background: #1a73e8;
}
</style>
